<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="text-container">
        <div class="title-area" v-show="launched !== 1 && $store.state.currentsurvey_id !== 0">
          <h1 class="page-title">
            <span>{{ screentexts[70]?screentexts[70].element_text:'Preview and launch' }}
            </span>
            <span
              class="ml-n1"
              :class="`${anon ? 'g-anon' : '' }`"
            >: {{ survey.survey_name }}
            </span>
          </h1>
        </div>
        <div v-show="$store.state.currentsurvey_id === 0">
          <h2>
            {{ screentexts[81]?screentexts[81].element_text:'No survey selected' }}
          </h2>
        </div>

        <div v-if="launched === 0 && $store.state.currentsurvey_id !== 0">
        <h3>
          {{ screentexts[71] ? screentexts[71].element_text : 'Survey Details' }}
        </h3>
        <div class="table-responsive d-table w-100 table-no-padding-first">
          <table class="table first-td-500 table-alternative">
            <tbody>
            <tr>
              <td>
                {{ screentexts[72] ? screentexts[72].element_text : 'Survey name' }}
              </td>
              <td class="editable normal-input">
                <input
                  v-if="editable"
                  v-model="survey.survey_name"
                  :class="['form-control', anon ? 'g-anon' : '']"
                  type="text"
                />
                <span v-else :class="`${anon ? 'g-anon' : '' }`">
                  {{ survey.survey_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Survey type
              </td>
              <td class="editable select-column">
                <select
                  v-if="false"
                  v-model="survey_type_id"
                  class="form-select"
                  @change="language_options_get(survey.surveytype_id);normvalues_countries_get();spotify_invoice_reference_get();"
                >
                  <option v-for="option in surveytype_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else>
                  {{ surveytype_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[73] ? screentexts[73].element_text : 'Start date and time' }}
              </td>
              <td class="editable">
                <div>
                  <div
                    v-if="editable"
                    class="d-flex"
                  >
                    <BaseDatePicker
                      id="start_date"
                      v-model="local_start_date"
                      :min-datetime="new Date().toLocaleDateString('sv-SE')"
                    />
                    <Datetime
                      id="survey_start_time"
                      v-model="local_start_time"
                      type="time"
                      input-class="form-control"
                      :format="'HH:mm'"
                      :placeholder="screentexts[62]?screentexts[62].element_text:'Select sending time'"
                      @input="checkstartdate"
                    />
                  </div>
                  <span v-else>
                    {{ local_start_date || 'Not set' }} {{ local_start_time }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[74] ? screentexts[74].element_text : 'End date and time' }}
              </td>
              <td class="editable">
                  <div
                    v-if="editable"
                  >
                    <BaseDatePicker
                      id="end_date"
                      v-model="survey.survey_end_date"
                      :min-datetime="new Date().toISOString()"
                    />
                  </div>
                  <span v-else>
                    {{ this.format_date(survey.survey_end_date) }} 23:59
                  </span>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[75] ? screentexts[75].element_text : 'Language' }}
              </td>
              <td class="editable select-column">
                <select
                  v-if="editable"
                  v-model="survey_language_id"
                  class="form-select"
                >
                  <option v-for="option in language_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else>
                  {{ language_name }}
                </span>
              </td>
            </tr>
            <tr v-if="Number(survey.survey_type_id) !== 3">
              <td>
                {{ screentexts[76] ? screentexts[76].element_text : 'Norm data' }}
              </td>
              <td class="editable select-column">
                <select
                  v-if="editable"
                  v-model="survey_normvalues_id"
                  class="form-select"
                >
                  <option v-for="option in norm_values_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else>
                  {{ normvalues_country_name }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

          <h3 class="mt-5">
              <!-- fa-icon name="rocket" class="mr-2"/ -->{{ screentexts[79]?screentexts[79].element_text:'Survey Participants' }}
          </h3>
          <div class="form-group">
            <button
              type="button"
              class="btn btn-secondary my-2"
              id="add-new-member"
              @click="toggleAddMember"
            >
              Add new participant
            </button>
          </div>
          <form
            class="bg-secondary add-member-container"
            v-if="isAddMemberVisible"
            novalidate
            @submit.stop.prevent
          >
            <div class="form-group">
              <label class="">
                {{ screentexts[167]?screentexts[167].element_text:'Form Type' }}
              </label>
              <select
                class="form-select"
                v-model="groupmember_formoption_id"
              >
                <option v-for="option in formoptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div
              class="form-group"
              v-show="groupmember_formoption_id === 1"
            >
              <label class="col-12 pl-0">
                {{ screentexts[164]?screentexts[164].element_text:'Email address' }}
              </label>
              <input
                v-model="groupmember_email"
                class="form-control col-12"
                :class="`${anon ? 'g-anon' : '' }`"
                type="text"
                :placeholder="screentexts[170]?screentexts[170].element_text:'Email Address'"
              >
              <span
                v-show="groupmember_email_valid === 'invalid'"
                class="text-danger"
              >Invalid or duplicate email address</span>
              <span v-show="groupmember_email_valid !== 'invalid'">&nbsp;</span>
            </div>
            <div class="form-group mb-0 d-flex justify-content-end align-items-center gap-3">
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="addgroupmember"
              >
                <span class="d-inline-block d-md-none d-lg-inline-block">{{ screentexts[175]?screentexts[175].element_text:'Add' }}</span>
              </button>
              <button
                type="button"
                class="btn btn-danger"
                @click="toggleAddMember"
              >
                <span class="d-inline-block d-md-none d-lg-inline-block">Cancel</span>
              </button>
            </div>
          </form>
          <div class="table-responsive launch-table-container">
            <BaseTable
              :fields="fields"
              :items="includedGroupMembers"
              :tbody-tr-class="rowClass"
              :small="true"
              class="actions-table save-cancel launch-table"
            >
            <template v-slot:cell(actions)="{ data }">
              <div class="d-flex justify-content-end" v-if="data.item">
                <div class="ellipsis-button">
                  <BaseDropdown right variant="link">
                    <template #button-content>
                      <i class="fa-solid fa-ellipsis"></i>
                    </template>
                    <li><a class="dropdown-item" href="#" @click.prevent="editGroupMember(data.item.id)">Edit</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="togglegroupmember(data.item.id)">Exclude from this survey</a></li>
                  </BaseDropdown>
                </div>
              </div>
            </template>

            <template v-slot:cell(groupmember_code)="{ data }">
              {{ data.item && data.item.groupmember_code ? data.item.groupmember_code : '' }}
            </template>

            <template v-slot:cell(groupmember_email)="{ data }">
              <div class="position-relative" v-if="data && data.item">
                <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
                <input
                  v-else
                  v-model="data.item.groupmember_email"
                  type="text"
                  class="form-control form-control-sm"
                  :class="{'g-anon': anon, 'text-danger': data.item.groupmember_email_valid === 'invalid'}"
                />
                <i
                  v-if="data.item.groupmember_email_valid === 'invalid' && data.item.editable"
                  class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                  title="Invalid email address"
                ></i>
              </div>
            </template>

            <template v-slot:cell(groupsurveymember_formoption_id)="{ data }">
              <div v-if="data && data.item">
                <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
                <select
                  v-else
                  v-model="data.item.groupsurveymember_formoption_id"
                  class="form-select form-select-sm"
                >
                  <option v-for="option in formoptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </template>
            </BaseTable>
          </div>

        <h3 class="mt-5 mb-3">
          Members not included in this survey
        </h3>

        <div class="table-responsive mb-5 launch-table-container">
          <BaseTable
            :fields="fields"
            :items="excludedGroupMembers"
            :tbody-tr-class="rowClass"
            :small="true"
            class="actions-table save-cancel excluded launch-table"
          >
          <template v-slot:cell(actions)="{ data }">
            <div class="d-flex justify-content-end" v-if="data.item">
              <div class="ellipsis-button">
                <BaseDropdown right variant="link">
                  <template #button-content>
                    <i class="fa-solid fa-ellipsis"></i>
                  </template>
                  <li><a class="dropdown-item" href="#" @click.prevent="editGroupMember(data.item.id)">Edit</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="togglegroupmember(data.item.id)">Include in this survey</a></li>
                </BaseDropdown>
              </div>
            </div>
          </template>

          <template v-slot:cell(groupmember_code)="{ data }">
            {{ data.item && data.item.groupmember_code ? data.item.groupmember_code : '' }}
          </template>

          <template v-slot:cell(groupmember_email)="{ data }">
            <div v-if="data && data.item">
              <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
              <input
                v-else
                v-model="data.item.groupmember_email"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'g-anon': anon }"
              />
            </div>
          </template>

          <template v-slot:cell(groupsurveymember_formoption_id)="{ data }">
            <div v-if="data && data.item">
              <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
              <select v-else v-model="data.item.groupsurveymember_formoption_id" class="form-select form-select-sm">
                <option v-for="option in formoptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </template>
          </BaseTable>
        </div>
        </div>
        <div class="row mt-3 mb-5">
          <div
            v-show="$store.state.currentsurvey_id !== 0"
            class="col-12"
          >

            <div v-show="launched === 0" class="d-flex justify-content-between">
                <router-link
                  v-show="launched === 0"
                  to="/create/group/survey/dates"
                  class="btn btn-secondary"
                >
                  &lt; Back
                </router-link>
                <button
                  v-show="launched === 0"
                  class="btn btn-primary btn-lg align-self-right"
                  @click="groupsurvey_launch"
                >
                  {{ !isscheduled()?screentexts[80]?screentexts[80].element_text:'Everything looks good. Launch the survey!':'Everything looks good. Schedule the survey' }}
                </button>
            </div>
            <p class="text-left text-lg" v-show="launched === 3">
              {{ screentexts[85]?screentexts[85].element_text:'Your survey has been launched!' }}
            </p>
            <p class="text-left text-lg" v-show="launched === 2">
              Your survey has been scheduled for launch on {{ survey.survey_start_date }} at {{ survey.survey_start_time }}
            </p>
            <div
              v-if="has_paper === 1 && launched > 1"
              class="d-none d-md-block text-lg mb-4"
            >
              {{ screentexts[86]?screentexts[86].element_text:'This survey has paper forms, you can choose to print these now,' }}
              <br>
              {{ screentexts[87]?screentexts[87].element_text:'or print them at a later time from the Survey Page.' }}
            </div>
            <div
              v-if="launched === 2 || launched === 3"
              class="d-flex flex-column flex-md-row gap-3 justify-content-between mt-4"
            >
              <button
                v-if="has_paper === 1"
                class="btn btn-success btn-lg"
                @click.prevent="print_paperforms"
              >
                <i class="fa-solid fa-print me-2"></i>Print the paper forms now
              </button>
              <router-link
                to="/"
                style="text-decoration: none;"
                :class="{'ms-auto': has_paper !== 1}"
              >
                <button class="btn btn-primary btn-lg">
                  {{ screentexts[88]?screentexts[88].element_text:'Return to My GDQ Management' }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { config } from '../../config'
import BaseDatePicker from './base/BaseDatePicker.vue'
import Datetime from './custom/Datetime.vue'
import BaseTable from './base/BaseTable.vue'
import BaseDropdown from './base/BaseDropdown.vue'

export default {
  name: 'CreateGroupSurveyLaunch',
  components: {
    Navbar,
    Breadcrumb,
    BaseDatePicker,
    Datetime,
    BaseTable,
    BaseDropdown
  },
  data () {
    return {
      isAddMemberVisible: false,
      survey: this.$store.state.currentsurvey,
      group_name: this.$store.state.currentgroup.group_name,
      languages: this.$store.state.languages,
      normvalues_countries: this.$store.state.normvalues_countries,
      fields: [
        { key: 'groupmember_code', label: 'Member', tdClass: 'd-none d-sm-table-cell py-1 align-middle', thClass: 'd-none d-sm-table-cell py-1 align-middle' },
        { key: 'groupmember_email', label: 'Email', class: 'editable email-column', tdClass: 'py-1 align-middle', thClass: 'py-1 align-middle' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', class: 'editable select-column', tdClass: 'py-1 align-middle', thClass: 'py-1 align-middle' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button', tdClass: 'text-end py-1 align-middle', thClass: 'text-end py-1 align-middle' }
      ],
      survey_type_id: this.$store.state.currentsurvey.survey_type_id,
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      surveytype_name: 'GDQ',
      launched: 0,
      has_mail: 0,
      has_paper: 0,
      screen_id: 9,
      screentexts: [],
      currentsurveymembers: [],
      groupmembers_grid: [],
      nextid: 10000000,
      original_member_data: {}, // To store the original data before editing
      editable: false,
      profile: this.$store.state.profile,
      spotify: this.$store.state.currentsurvey.spotify,
      survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
      norm_values_options: [],
      language_options: [],
      surveytype_options: [],
      survey_language_id: this.$store.state.currentsurvey.survey_language_id,
      serverdate: this.serverdate_get(),
      loading: false,
      local_start_date: null,
      local_start_time: null
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    formoptions: {
      get () {
        const items = this.$store.state.formoptions
        const formoptions = []
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].id,
            text: items[i].formoption_name
          }
          formoptions.push(option)
        }
        return formoptions
      }
    },
    surveystartdate: {
      get () {
        return this.$store.state.currentsurvey.survey_start_date
      },
      set () {
        return true
      }
    },
    surveymembers: {
      get () {
        const groupmembers_db = []
        const currentsurveymembers = this.$store.state.currentsurveymembers
        const currentgroupmembers = this.$store.state.currentgroupmembers

        for (let i = 0; i < currentsurveymembers.length; i++) {
          const surveymember = currentsurveymembers[i]

          const groupmember = currentgroupmembers.find(gm => Number(gm.id) === Number(surveymember.groupmember_id))

          if (groupmember) {
            const includedFlag = surveymember.included_in_survey === 1 || surveymember.included_in_survey === true || surveymember.included_in_survey === '1'
            groupmembers_db.push({
              ...groupmember,
              groupsurveymember_formoption_id: surveymember.groupsurveymember_formoption_id,
              newid: surveymember.id,
              included_in_survey: includedFlag ? 1 : 0,
              editable: surveymember.editable
            })
          }
        }
        return groupmembers_db
      }
    },
    includedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey === 1 || member.included_in_survey === true || member.included_in_survey === '1')
    },

    excludedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey === 0 || member.included_in_survey === false || member.included_in_survey === '0')
    },
    reminder: {
      get () {
        if (this.$store.state.currentsurvey.survey_reminder === 1) {
          return 'Yes'
        } else {
          return 'No'
        }
      },
      set () {
        return true
      }
    },
    remindparticipants: {
      get () {
        if (this.$store.state.currentsurvey.survey_remindparticipants === 1) {
          return 'Yes'
        } else {
          return 'No'
        }
      },
      set () {
        return true
      }
    },
    language_name: {
      get () {
        const langid = this.survey_language_id
        let language_name = ''
        for (let i = 0; i < this.languages.length; i++) {
          if (Number(this.languages[i].id) === Number(langid)) {
            language_name = this.languages[i].language_name
          }
        }
        // var language_name = this.languages[this.$store.state.currentsurvey.survey_language_id];
        return language_name
      },
      set () {
        return true
      }
    },
    normvalues_country_name: {
      get () {
        let normvalues_country_name = ''
        for (let i = 0; i < this.normvalues_countries.length; i++) {
          if (Number(this.normvalues_countries[i].country_id) === Number(this.survey_normvalues_id)) {
            normvalues_country_name = this.normvalues_countries[i].country_name
          }
        }
        return normvalues_country_name
      },
      set () {
        return true
      }
    }
  },
  watch: {
    addingsurveymember: function () {
      this.survey_get()
    },
    surveymembers () {
      this.syncGroupMembersGrid()
    },
    'survey.survey_start_date' () {
      this.init_local_start_datetime()
    },
    'survey.survey_start_time' () {
      this.init_local_start_datetime()
    }
  },
  async created () {
    await this.profile_get()
    await this.languages_get()
    await this.screentexts_get()
    await this.load_groupmembers()
    await this.survey_get()
    // Initialize local dates after survey is loaded
    this.init_local_start_datetime()
    await this.surveytype_get()
    await this.formoptions_get()
    await this.normvalues_countries_get()
    await this.language_options_get(this.survey_type_id)
    await this.spotify_invoice_reference_get()
  },
  beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    // if (to.path == '/') {
    //   this.groupsurvey_launch();
    // }
    next()
  },
  methods: {
    syncGroupMembersGrid () {
      this.groupmembers_grid = this.surveymembers.map(member => ({
        ...member,
        included_in_survey: member.included_in_survey === 1 || member.included_in_survey === true || member.included_in_survey === '1' ? 1 : 0,
        groupsurveymember_formoption_id: Number(member.groupsurveymember_formoption_id),
        editable: false
      }))
    },
    async load_groupmembers () {
      await this.$store.dispatch('group_fetch')
        .then(() => {
          return this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
        })
    },
    serverdate_get: async function () {
      await this.$store.dispatch('serverdate_fetch')
        .then((resp) => {
        // console.log('serverdate_get', resp.data);
          this.serverdate = resp.data
          return resp.data
        })
    },
    toggleEditable () {
      this.editable = !this.editable
      const rows = document.querySelectorAll('.table-alternative tr')
      rows.forEach(row => {
        if (this.editable) {
          row.classList.add('editable-row')
        } else {
          row.classList.remove('editable-row')
          this.surveytype_get()
        }
      })
    },
    rowClass (item) {
      return item.editable ? 'editable-row' : ''
    },
    formoptions_get: async function () {
      await this.$store.dispatch('formoptions_fetch')
    },
    toggleAddMember () {
      this.isAddMemberVisible = !this.isAddMemberVisible
    },
    getFormOptionText (id) {
      const option = this.formoptions.find(option => Number(option.value) === Number(id))
      return option ? option.text : ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_grid[index].groupmember_code = this.original_member_data[id].groupmember_code
        this.groupmembers_grid[index].groupmember_email = this.original_member_data[id].groupmember_email
        this.groupmembers_grid[index].groupmember_mobile = this.original_member_data[id].groupmember_mobile
        this.groupmembers_grid[index].groupmember_formoption_id = this.original_member_data[id].groupmember_formoption_id
        this.groupmembers_grid[index].groupsurveymember_formoption_id = this.original_member_data[id].groupsurveymember_formoption_id
        this.groupmembers_grid[index].groupmember_status_id = this.original_member_data[id].groupmember_status_id
        this.groupmembers_grid[index].included_in_survey = this.original_member_data[id].included_in_survey
        this.groupmembers_grid[index].editable = false
        delete this.original_member_data[id]
      }
    },

    saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        if (this.validateEditedMember(member)) {
          member.editable = false
          delete this.original_member_data[id]
          this.updatesurvey(false)
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },

    validateEditedMember (member) {
      if (member.groupsurveymember_formoption_id !== 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      } else {
        return this.parse_email(member.groupmember_email)
      }
    },

    async languages_get () {
      await this.$store.dispatch('languages_fetch')
        .then((res) => {
          this.languages = res.data.result
        })
    },

    async language_options_get (survey_type_id) {
      const filter = {}
      if (this.spotify === '1' && Number(survey_type_id) === 2) {
        this.language_options = []
        this.language_options.push({
          value: 38,
          text: 'English'
        })
        this.survey_language_id = 38
        return true
      }
      switch (survey_type_id) {
        case '1':
          filter.language_enabled = {
            operator: '=',
            value: '1'
          }
          break
        case '2':
          filter.language_enabled_gdq_short = {
            operator: '=',
            value: '1'
          }
          break
        case '3':
          filter.language_enabled_osc = {
            operator: '=',
            value: '1'
          }
          break
        default:
          filter.language_enabled = {
            operator: '=',
            value: '1'
          }
      }
      await this.$store.dispatch('records_readall', { table_name: 'g_languages', filter, orderby: 'language_name' })
        .then((resp) => {
          this.language_options = []
          for (let i = 0; i < resp.data.result.length; i++) {
            this.language_options.push({
              value: resp.data.result[i].id,
              text: resp.data.result[i].language_name
            })
          }
        })
      return true
    },
    async spotify_invoice_reference_get () {
      if (this.profile.spotify === '1') {
        if (this.spotify === '1' && Number(this.survey_type_id) === 2) {
          await this.$store.dispatch('syspref_get', { name: 'spotify_invoice_reference' })
            .then((resp) => {
              this.survey_invoice_reference = resp.data.value
            })
        } else {
          this.survey_invoice_reference = ''
        }
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    screentexts_get: async function () {
      const screentexts = []
      const filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter })
        .then((resp) => {
          const dbtexts = resp.data.result
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    print_paperforms () {
      this.$store.dispatch('paperforms_fetch', { survey_id: this.$store.state.currentsurvey_id })
        .then((resp) => {
          const paperformsurl = config.report_url + '/gdq_paperforms.php?i=' + resp.data.id
          window.open(paperformsurl)
        })
    },
    async surveytype_get () {
      await this.$store.dispatch('record_read', { table_name: 'g_surveytypes', id: this.survey_type_id })
        .then((resp) => {
          this.surveytype_name = resp.data.surveytype_name
        })
    },
    survey_get: async function () {
      this.has_paper = 0
      this.has_mail = 0
      await this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id }).then((resp) => {
        this.survey = resp.data
        this.$store.dispatch('groupsurveymembers_fetch', { survey_id: this.survey.id })
          .then((resp) => {
            const members = resp.data.result
            this.currentsurveymembers = members
            for (let i = 0; i < members.length; i++) {
              const formOption = Number(members[i].groupsurveymember_formoption_id)
              const included = members[i].included_in_survey === 1 || members[i].included_in_survey === true || members[i].included_in_survey === '1'
              if (formOption === 1) { this.has_mail = 1 }
              if (formOption === 2) { this.has_paper = 1 }
              members[i].editable = false
              members[i].included_in_survey = included ? 1 : 0
            }
            this.syncGroupMembersGrid()
          // if (this.survey.survey_status_id == 1) {
          //   var data = {
          //     id: this.$store.state.currentsurvey.id,
          //     survey_status_id: 2
          //   }
          //   this.$store.dispatch('groupsurvey_save', { survey: data })
          //     .then(() => {
          //       this.$store.dispatch('groupsurvey_fetch', { id: this.survey.id }).then((resp) => {
          //         this.survey = resp.data;
          //       })
          //     })
          // }
          })
      })
    },
    togglegroupmember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          this.groupmembers_grid[i].included_in_survey = this.groupmembers_grid[i].included_in_survey === 1 ? 0 : 1
          this.updatesurvey(false)
        }
      }
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
    },
    validategroupmember () {
      let formok = true
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (this.groupmember_formoption_id === 1) {
        if (this.groupmember_email === '') {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
        // eslint-disable-next-line
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.groupmember_email) == false) {
        if (!this.parse_email(this.groupmember_email)) {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
      }
      return formok
    },
    profile_get: async function () {
      await this.$store.dispatch('profile_fetch')
        .then((resp) => {
          this.profile = resp.data
          this.$store.dispatch('surveytypes_fetch')
            .then((resp) => {
              const items = resp.data.result
              const options = []
              for (let i = 0; i < items.length; i++) {
                const option = {
                  value: items[i].id,
                  text: items[i].surveytype_name
                }
                options.push(option)
              }
              this.surveytype_options = options
            })
        })
      if (this.profile.spotify === '1') { this.spotify = '1' }
    },
    normvalues_countries_get: async function () {
      const survey_type_id = this.survey_type_id
      await this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          const options = []
          for (let i = 0; i < resp.data.length; i++) {
            if (resp.data[i].country_id === 999 || Number(survey_type_id) === 1) {
              const option = {
                value: resp.data[i].country_id,
                text: resp.data[i].country_name
              }
              options.push(option)
            }
          }
          this.norm_values_options = options
        })
    },
    updatesurvey (adding) {
      const newmember = {
        id: this.nextid, // id
        groupmember_code: '', // groupmember_code
        groupmember_name: this.groupmember_name,
        groupmember_email: this.groupmember_email,
        groupmember_mobile: this.groupmember_mobile,
        groupmember_formoption_id: this.groupmember_formoption_id,
        groupsurveymember_formoption_id: this.groupmember_formoption_id,
        groupmember_status_id: 0,
        included_in_survey: true,
        newid: 0,
        _rowVariant: 'success'
      }
      if (newmember !== null && adding) {
        this.nextid++
        this.cleargroupmember()
        this.groupmembers_grid.push(newmember)
        const data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('addingsurveymember_set', {
          addingsurveymember: true
        })
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          this.survey_get()
        })
      } else {
        const data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          this.survey_get()
        })
      }
    },
    addgroupmember () {
      if (this.validategroupmember()) {
        this.updatesurvey(true)
      }
    },
    async groupsurvey_save () {
      const startCET = this.local_to_cet(this.local_start_date, this.local_start_time)
      const survey = {
        id: this.$store.state.currentsurvey_id,
        survey_name: this.survey.survey_name,
        survey_language_id: this.survey_language_id,
        survey_normvalues_id: this.survey_normvalues_id,
        survey_type_id: this.survey_type_id,
        survey_invoice_reference: this.survey_invoice_reference,
        survey_start_date: startCET.date,
        survey_end_date: this.format_date(this.survey.survey_end_date),
        survey_start_time: startCET.time,
        survey_reminder_date: this.survey.survey_reminder_date,
        survey_reminder_email: this.survey.survey_reminder_email,
        survey_reminder_mobile: this.survey.survey_reminder_mobile,
        survey_reminder: this.survey.survey_reminder,
        survey_status_id: this.survey.survey_status_id,
        spotify: this.profile.spotify === '1' && this.survey_type_id === '2' && this.spotify === '1' ? '1' : '0'
      }
      await this.$store.dispatch('groupsurvey_save', { survey })
        .then(async (resp) => {
          this.survey_id = resp.data.id
          const data = {
            survey_id: this.survey_id,
            survey_language_id: this.survey_language_id,
            survey_type_id: this.survey.survey_type_id
          }
          await this.$store.dispatch('groupsurvey_changelanguage', data)
            .then(async (resp) => {
              this.survey_invitation_text = resp.data.survey_invitation_text
              this.survey_invitation_subject = resp.data.survey_invitation_subject
              this.survey_get()
              await this.$store.dispatch('groupsurvey_setcurrent', { survey_id: this.survey_id })
              return true
            })
        })
    },
    async groupsurvey_launch () {
      this.loading = true
      this.launched = 1
      
      // Set status before saving
      if (this.isscheduled()) {
        this.survey.survey_status_id = 2
      } else {
        this.survey.survey_status_id = 3
      }
      
      await this.groupsurvey_save()
        .then(async () => {
          if (this.isscheduled()) {
            this.launched = 2
          } else {
            const mailmembers = []
            for (let i = 0; i < this.$store.state.currentsurveymembers.length; i++) {
              if (Number(this.$store.state.currentsurveymembers[i].groupsurveymember_formoption_id) === 1) {
                mailmembers.push(this.$store.state.currentsurveymembers[i])
              }
            }
            const payload = {
              survey: this.survey,
              surveymembers: mailmembers,
              mail_subject: this.$store.state.currentsurvey.survey_invitation_subject,
              mail_text: this.$store.state.currentsurvey.survey_invitation_text,
              mail_consultant_text: this.$store.state.currentsurvey.survey_invitation_consultant_text,
              mail_cc: this.$store.state.currentsurvey.survey_invitation_cc,
              mail_type: 'Invitation'
            }
            await this.$store.dispatch('groupsurvey_mail', payload)
            this.launched = 3
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Convert a CET naive date+time to a UTC Date object.
    // Handles CET (+01:00) and CEST (+02:00) automatically.
    cet_to_date (datePart, timePart) {
      if (!datePart || !timePart || String(timePart).length !== 5) return null
      const attempt = new Date(`${datePart}T${timePart}:00+01:00`)
      const check = attempt.toLocaleString('sv-SE', { timeZone: 'Europe/Berlin' }).split(' ')[1].substring(0, 5)
      return check === timePart ? attempt : new Date(`${datePart}T${timePart}:00+02:00`)
    },
    // Convert local date (YYYY-MM-DD) + local time (HH:MM) to CET {date, time}.
    local_to_cet (localDate, localTime) {
      if (!localDate || !localTime) return { date: localDate || '', time: localTime || '' }
      const d = new Date(`${String(localDate).substring(0, 10)}T${localTime}:00`)
      return {
        date: d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' }),
        time: d.toLocaleTimeString('sv-SE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
      }
    },
    // Initialize local_start_date and local_start_time from the store's CET values.
    init_local_start_datetime () {
      const d = this.cet_to_date(this.survey.survey_start_date, this.survey.survey_start_time)
      if (d) {
        // Display in CET timezone to match what was saved
        this.local_start_date = d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
        this.local_start_time = d.toLocaleTimeString('sv-SE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
      } else {
        this.local_start_date = null
        this.local_start_time = null
      }
    },
    format_date (date) {
      if (!date) return ''
      if (date instanceof Date) {
        return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
      }
      return String(date).substring(0, 10)
    },
    default_end_date () {
      let date = new Date(this.serverdate)
      date = this.add_months(date, 3)
      return date.toISOString()
    },
    default_reminder_date () {
      const date = new Date(this.serverdate)
      date.setDate(date.getDate() + 87)
      return date.toISOString()
    },
    add_months (date, count) {
      if (date && count) {
        const d = (date = new Date(+date)).getDate()
        date.setMonth(date.getMonth() + count, 1)
        const m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    checkstartdate () {
      if (this.loading === true) { return true }
      this.showtimeadjust = false
      if (!this.local_start_date || !this.local_start_time) return
      const surveydate = new Date(`${this.local_start_date}T${this.local_start_time}:00`)
      if (surveydate < new Date(this.serverdate)) {
        this.showtimeadjust = true
      }
    },
    isscheduled () {
      if (!this.local_start_date || !this.local_start_time) return false
      const surveydate = new Date(`${this.local_start_date}T${this.local_start_time}:00`)
      return surveydate > new Date(this.serverdate)
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.launch-table.table {
  margin-bottom: 0;
}

.launch-table.table-sm td,
.launch-table.table-sm th {
  padding: 0.25rem 0.5rem;
  line-height: 1.25;
}

.launch-table .form-control-sm,
.launch-table .form-select-sm {
  padding: 0.25rem 0.4rem;
  line-height: 1.25;
  height: 30px;
}

.launch-table .dropdown .btn-sm {
  padding: 0.25rem 0.4rem;
}
</style>
